import React, { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import MaintenanceHeroSection from './components/MaintenanceHeroSection';
import ServiceOverviewSection from './components/ServiceOverviewSection';
import CertifiedEngineersSection from './components/CertifiedEngineersSection';
import AnnualInspectionSection from './components/AnnualInspectionSection';
import EmergencyRepairSection from './components/EmergencyRepairSection';
import ThirdPartySupportSection from './components/ThirdPartySupportSection';
import DJIRepairCenterSection from './components/DJIRepairCenterSection';
import InsuranceDetailsSection from './components/InsuranceDetailsSection';
import FAQSection from './components/FAQSection';
import LocationsInfoSection from './components/LocationsInfoSection';
import ContactFormSection from './components/ContactFormSection';

const MaintenanceServicePage: React.FC = () => {
  useEffect(() => {
    // SEO設定
    document.title = '農業ドローン・自動操舵システム点検整備｜DJI認定整備士在籍｜佐賀・福岡・鹿児島｜IDS教習所';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'DJI推薦修理センター認定。DJI農業ドローン（AGRAS全機種）、FJD・EFIX自動操舵システムの定期点検・修理・メンテナンスに対応。DJI認定整備士在籍。佐賀県多久市・佐賀市・鹿児島県日置市の3拠点で迅速対応。年間300台以上の点検実績。無料相談受付中。');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', '農業ドローン点検,DJI修理,AGRAS整備,自動操舵メンテナンス,DJI認定整備士,DJI推薦修理センター,FJD整備,EFIX修理,定期点検,佐賀,福岡,鹿児島,IDS教習所,年間点検,迅速対応');
    }

    // 構造化データ
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Service",
          "name": "農業ドローン・自動操舵システム点検整備サービス",
          "description": "DJI推薦修理センター認定。DJI農業ドローン（AGRAS全機種）、FJD・EFIX自動操舵システムの定期点検・修理・メンテナンスに対応。",
          "provider": {
            "@type": "Organization",
            "name": "IDS教習所グループ"
          },
          "areaServed": [
            {
              "@type": "Place",
              "name": "佐賀県"
            },
            {
              "@type": "Place",
              "name": "福岡県"
            },
            {
              "@type": "Place",
              "name": "鹿児島県"
            }
          ],
          "serviceType": "ドローンメンテナンス"
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "ホーム",
              "item": siteUrl
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "点検整備サービス",
              "item": `${siteUrl}/maintenance-service`
            }
          ]
        }
      ]
    });
    document.head.appendChild(script);

    // Add H1 tag for maintenance service page
    const h1 = document.createElement('h1');
    h1.textContent = '点検整備サービス';
    h1.style.position = 'absolute';
    h1.style.left = '-9999px';
    h1.style.fontSize = '1px';
    document.body.appendChild(h1);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
      if (document.body.contains(h1)) {
        document.body.removeChild(h1);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <MaintenanceHeroSection />
        <ServiceOverviewSection />
        <CertifiedEngineersSection />
        <AnnualInspectionSection />
        <EmergencyRepairSection />
        <ThirdPartySupportSection />
        <DJIRepairCenterSection />
        <InsuranceDetailsSection />
        <FAQSection />
        <LocationsInfoSection />
        <ContactFormSection />
      </main>
      <Footer />
    </div>
  );
};

export default MaintenanceServicePage;
